// extracted by mini-css-extract-plugin
export default {"container":"styles_container__X34oF","checkbox":"styles_checkbox__wmlCJ","checked":"styles_checked__P67f-","label":"styles_label__z5CJd"};